import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'


@Component({
  selector: 'app-schedule-administration',
  templateUrl: './schedule-administration.component.html',
  styleUrls: ['./schedule-administration.component.css']
})
export class ScheduleAdministrationComponent implements OnInit {

  schedulearray=[];
  oldschedulearray=[];
  removalschedulearray=[];
  selectedsalesrep;
  salesrepselected=false;
mainSalesRep;
allSalesRep=[];
  searchForm: FormGroup;
searchText;
  scheduleUser=[];
  currentUser: User;
  username;
  branch;
  role;
  success;
  error;
  loggedInUsername
  loggedInUserFullname;
  loggedInUserBranch;
  loggedInUserId;
  addSalesRepToMainListForm:FormGroup;
  addMultipleSalesRepToMainListForm:FormGroup;

  validationMessages = {
    'name': {
      'required': 'Product Name is required'
    },
    'descriptionTitle': {
      'required': 'Description Title is required'
    },
    'description': {
      'required': 'Description is required'
    },
  
    'email': {
      'required': 'Email is required',
      'pattern' : 'Please enter a valid email'
    },
  
   'sku': {
    'required': 'required'
  },
  'category': {
    'required': 'required'
  },
  'ageGroup': {
    'required': 'required'
  },
  'branch': {
    'required': 'Branch is required'
  },

  
  };
  
  
  formErrors = {
    'name': '',
    'sku': '',
    'descriptionTitle': '',
    'description': '',
  
  }

  constructor(private fb: FormBuilder,
      private router: Router,
      private _location: Location,
      private actroute: ActivatedRoute,
      private _authenticationService: AuthenticationService,
      public datepipe: DatePipe,
      private modalService: NgbModal,
      private _appointment: AppointmentService,)
      {
        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser){
          this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
          this.branch=this.currentUser.branch;
          this.role=this.currentUser.role;
  
  
          this.loggedInUsername=this.currentUser.userName;
          this.loggedInUserFullname= this.username;
          this.loggedInUserBranch= this.branch
          this.loggedInUserId=this.currentUser.userName;
      
          
      
         }
      }

  ngOnInit(): void {

    this.getScheduleUser(this.branch);

    this.getAllSalesRep();

    this.addSalesRepToMainListForm = this.fb.group({
      modalMsg: new FormControl(''),
      userID:new FormControl(''),
      newMainSalesRepName: new FormControl('', [Validators.required]),
      branch: new FormControl(this.branch),
      email: new FormControl(''),
      phone: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });


    this.addMultipleSalesRepToMainListForm = this.fb.group({
      removeMainSalesRepList: new FormControl(this.removalschedulearray),
      newMainSalesRepList: new FormControl(this.schedulearray),
      branch: new FormControl(this.branch),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });

  }
/*************************************************************************************8 */
getScheduleUser(branch){
 // branch='8899 Jane St';
  console.log(branch);
  if (branch != "None" || branch!="") {
    this._appointment.getMainSalesRepByBranch(branch).subscribe(
      (res) => {
        this.mainSalesRep = res;

        console.log(this.mainSalesRep);
if(this.mainSalesRep!=''){
  for (var i = 0; i < res.length; i++) {
var item={'userID':res[i].userID, 'fullName': res[i].fullName, 'email': res[i].email, 'branch': res[i].branch, 'phone': res[i].phone, 'expertise':res[i].expertise};
    this.schedulearray.push(item);
    this.oldschedulearray.push(item);

  }

 // this.schedulearray=this.mainSalesRep;
  

 
}
//this.oldschedulearray=this.schedulearray;
console.log(this.schedulearray);
 
      }
      ,
      (err) => {
        this.error = err;
      }
    );
  }
  console.log(this.schedulearray);
}

/************************************************************************************** */
selectSalesRep(event,controlname,value){
  if(controlname=='schedule'){

    // for (let i = 0; i < this.schedulearray.length; i++) {
console.log(value);
      //for (let i = 0; i < this.schedulearray.length; i++) {
        //if(this.schedulearray[i].userID==value.userID){
          console.log(this.schedulearray.includes(value));
    //if(this.schedulearray.includes(value)){
      if(this.schedulearray.some(array=> array.userID===value.userID)){
     // const i=this.schedulearray.indexOf(value)
     const i=this.schedulearray.findIndex(array=> array.userID===value.userID);
      this.schedulearray.splice(i,1);
    //  if(this.oldschedulearray.includes(value)){
      if(this.oldschedulearray.some(array=> array.userID===value.userID)){  
        this.removalschedulearray.push(value);
      }
    
    }

    else{
      this.schedulearray.push(value);
 //     if(this.removalschedulearray.includes(value)){
  if(this.removalschedulearray.some(array=> array.userID===value.userID)){  
    const j=this.removalschedulearray.findIndex(array=> array.userID===value.userID);
    // const j=this.removalschedulearray.indexOf(value)
        this.removalschedulearray.splice(j,1);
      }
     // console.log(this.schedulearray);
     
    }
 
    }

    
   
     console.log('old',this.oldschedulearray)
      console.log(this.schedulearray)
      console.log(this.removalschedulearray)
  this.addMultipleSalesRepToMainListForm.patchValue({
    removeMainSalesRepList: this.removalschedulearray,
newMainSalesRepList:this.schedulearray
  });


}
/*************************************************************************************8 */
  
deleteSalesRepFromMainList(salesrep){

  this._appointment.deleteSalesRepFromMainList(this.loggedInUsername,salesrep).subscribe(
    response => {
      console.log('Success!', response);

      this.modalService.dismissAll();
    // this.refreshFormFieldList(table);

     this.getScheduleUser(this.branch);

     // document.getElementById("openSuccessModalButton").click();

    },

    error => {
      console.error('Error!', error);
      this.error = error.error.text;
      this.modalService.dismissAll();
      document.getElementById("openErrorModalButton").click();
    }
  );


}

/*************************************************************************************8 */

getSalesRepDetails(salesrepID) {
  console.log(salesrepID);
  if (salesrepID != "None") {
    this._appointment.getSalesRepByPID(salesrepID,this.branch).subscribe(
      (res) => {
        this.selectedsalesrep = res;
        console.log(this.selectedsalesrep);
        this.salesrepselected = true;
   
        if(this.selectedsalesrep!=''){
          this.patchSalesRep(this.selectedsalesrep[0]);
        }
      }
      ,
      (err) => {
        this.error = err;
      }
    );
  }
  else {
    this.salesrepselected = true;
  }

}

/*******************************************************************8 */


isChecked(value) {
  // console.log(this.productThicknesses);
  //console.log(value);
  // if(controlName=='thicknesses'){
     //console.log(value,this.thicknessesarray.includes(value))
     for (let i = 0; i < this.schedulearray.length; i++) {
    // this.schedulearray.forEach(element => {
       //console.log(element['userID']);

      // console.log(i,this.schedulearray[i])
       if(this.schedulearray[i].userID==value){
        //  console.log(this.schedulearray[i]['userID'],value);
        return true;
       }
         //return false;
       
       
     }
     
 //  console.log( this.schedulearray.includes(value));
 
     }

/************************************************************************* */     

patchSalesRep(selectedsalesrep){
  console.log(selectedsalesrep);
this.addSalesRepToMainListForm.patchValue({
  userID:selectedsalesrep.userID,
  newMainSalesRepName: selectedsalesrep.fullName,
  email: selectedsalesrep.email,
  phone: selectedsalesrep.phone,
})

}

  /************************************************************* */
  getAllSalesRep(){

    this._appointment.getSalesRepByBranch(this.branch).subscribe(
      (res) => {
       // this.allSalesRep = res;
       console.log(res);
     //  console.log(this.mainSalesRep);
   //    this.allSalesRep.forEach(x=> {
    for (let i = 0; i < res.length; i++) {
    this.allSalesRep.push({'userID':res[i].userID, 'fullName': res[i].fullName, 'email': res[i].email, 'branch': res[i].branch, 'phone': res[i].phone, 'expertise':res[i].expertise});
    }
        //console.log(x);
     //   this.allSalesRep=this.allSalesRep.filter(rep=> !this.mainSalesRep.filter(main=>main.email===rep.email).lenght)
   //   });
     //   console.log(this.allSalesRep);

     //   console.log('old',this.oldschedulearray)
      //  console.log(this.schedulearray)
       // console.log(this.removalschedulearray)
      }
      ,
      (err) => {
        this.error = err;
      }
    );
  }



  /******************************************************** */
  //ADD SALES REP
  
  /************************************************************* */


  addSalesRepToMainlist(){
    this.logValidationErrors(this.addSalesRepToMainListForm );
    
    console.log(this.addSalesRepToMainListForm.value);
          this._appointment.add_new_salesRep_to_mainlist_insert(this.addSalesRepToMainListForm.value)
       .subscribe(//subscribe to Observable
         response => {console.log('Success!', response);
         this.success=response['SUCCESS'];
         this.addSalesRepToMainListForm.reset;        
        // document.getElementById("openSuccessModalButton").click();
         this.modalService.dismissAll();
         this.getScheduleUser(this.branch);
       },
         error => {console.error('Error!', error);
         this.error=error.error.text ;
       }       
       );
    
    }
  
    
  /******************************************************** */
  //ADD MULTIPLE SALES REP
  
  /************************************************************* */


  addMultipleSalesRepToMainlist(){
    this.logValidationErrors(this.addMultipleSalesRepToMainListForm );
    
    console.log(this.addMultipleSalesRepToMainListForm.value);
          this._appointment.add_multiple_new_salesRep_to_mainlist_insert(this.addMultipleSalesRepToMainListForm.value)
       .subscribe(//subscribe to Observable
         response => {console.log('Success!', response);
         this.success=response['SUCCESS'];
         this.addMultipleSalesRepToMainListForm.reset;        
         document.getElementById("openSuccessModalButton").click();
         this.modalService.dismissAll();
         this.getScheduleUser(this.branch);
       },
         error => {console.error('Error!', error);
         this.error=error.error.text ;
       }       
       );
    
    }


  deleteProductFormFieldItem(table,item){
    console.log(table)
        this._appointment.deleteSalesRepFromMainList(this.loggedInUsername,item).subscribe(
          response => {
            console.log('Success!', response);
      
            this.modalService.dismissAll();
           this.refreshFormFieldList(table);
      
           
            //document.getElementById("openSuccessModalButton").click();
      
          },
      
          error => {
            console.error('Error!', error);
            this.error = error.error.text;
            this.modalService.dismissAll();
            document.getElementById("openErrorModalButton").click();
          }
        );
      }



        refreshFormFieldList(table: any) {
         if(table=='schedule'){
          this.getScheduleUser(this.branch);
         } 
    }



    

  addModal(modal){
    //this.getSalesRep(this.branch);
    var finalmessage= "Please select the name: "
  
    
  
  this.modalService.open(modal, {
    centered: true,
    backdrop: 'static'
  });
    
  }


  backClicked() {
    this._location.back();
  }


    
    
  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
        //      console.log(key);
  
              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }
  
    });
  }

}



